import { commingsoonimg } from "../../constants/imports";

 

export default () => {
   

 

  return (
    <div className=" p-4 md:p-10 h-full flex-col px-6  overflow-x-hidden overflow-y-hidden  md:pt-1  w-full flex justify-center items-center  ">
      
<h1  className="font-bold text-xl text-primary text-center">Coming soon on the mobile app</h1>


<img  className ="animate-pulse" src={commingsoonimg}/>
<p className="text-blue-500 font-light text-lg text-center">This particular feature is only available on the mobile app which is launching soon! </p>

    </div>
  );
};
